module.exports = __webpack_public_path__ + "img/_SDI9422-1600.7c52015b.webp";